const DITypes = {
  JsonRpcDispatcher: Symbol('OpenMarketJsonRpcDispatcher'),
  DispatcherFactory: Symbol('OpenMarketDispatcherFactory'),
  AdapterFactory: Symbol('OpenMarketAdapterFactory'),
};

export default DITypes;
